import React from 'react';
import { Users, MessageSquare, Calendar, Clock } from 'lucide-react';

const CommunityPage = () => {
  const groups = [
    {
      name: "ADHD Parents Support",
      members: 2847,
      description: "Support for parents raising children with ADHD",
      activity: "Very Active"
    },
    {
      name: "ADHD in the Workplace",
      members: 1923,
      description: "Strategies and support for career success",
      activity: "Active"
    },
    {
      name: "Young Adults with ADHD",
      members: 3421,
      description: "For those navigating adulthood with ADHD",
      activity: "Very Active"
    },
    {
      name: "ADHD Partners & Spouses",
      members: 1567,
      description: "Support for partners of people with ADHD",
      activity: "Active"
    }
  ];

  return (
    <div>
      <section className="bg-gradient-to-r from-teal-600 to-emerald-600 text-white py-12">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl font-bold mb-4">Community</h1>
          <p className="text-xl opacity-90">Connect with others who understand your journey</p>
        </div>
      </section>

      <section className="py-12">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold mb-8">Support Groups</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-6xl mx-auto">
            {groups.map((group, index) => (
              <div key={index} className="bg-white rounded-xl shadow-md p-6">
                <div className="flex items-start justify-between mb-4">
                  <div>
                    <h3 className="text-xl font-bold mb-2">{group.name}</h3>
                    <p className="text-gray-600">{group.description}</p>
                  </div>
                  <div className="bg-teal-100 text-teal-800 px-3 py-1 rounded-full text-sm font-semibold">
                    {group.activity}
                  </div>
                </div>
                <div className="flex items-center justify-between">
                  <div className="flex items-center text-gray-500">
                    <Users className="mr-2" size={18} />
                    {group.members.toLocaleString()} members
                  </div>
                  <button className="bg-teal-600 text-white px-6 py-2 rounded-full font-semibold hover:bg-teal-700 transition">
                    Join Group
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default CommunityPage;